module.exports = __webpack_public_path__ + "img/picDemo.e3ae00ee.jpg";